<template>
    <div class="digital-classrooms-event">
        <template v-if="isMobileView">
            <div class="digital-classrooms-event__name">
                <router-link :to="getRouteToCourse(event.course)">{{ event.title }}</router-link>
            </div>
        </template>
        <div class="digital-classrooms-event__table-row">
            <template v-if="getEventDates.length > 1">
                <template v-if="isDesktopView">
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__name">
                        <router-link :to="getRouteToCourse(event.course)">{{ event.title }}</router-link>
                    </div>
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__date">
                        <span class="digital-classrooms-event__date-range">{{getEventDates[0]}} - {{getEventDates[getEventDates.length - 1]}}</span>
                        <span :class="['digital-classrooms-event__show-dates-and-times-signups', {'signed' : isUserSignedToEvent}]" @click="toggleDatesDropDown">
                            <span v-html="$t('DigitalClassrooms.show_dates_and_times')"></span>
                            <span :class="['icon-dropdown', getClassForDateDropDown]"></span>
                        </span>
                    </div>
                    <div class="digital-classrooms-event__table-cell"></div>

                    <div class="digital-classrooms-event__table-cell">{{ getIntervalEventsTotalDuration }}</div>
                    <div v-if="!isPastEvent" class="digital-classrooms-event__table-cell">{{ getEventSeats }}</div>
                    <div v-else class="digital-classrooms-event__table-cell"></div>
                </template>
                <template v-else>
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__date">
                        <span class="digital-classrooms-event__date-range">{{getEventDates[0]}} - {{getEventDates[getEventDates.length - 1]}}</span>
                        <span :class="['digital-classrooms-event__show-dates-and-times-signups', {'signed' : isUserSignedToEvent}]" @click="toggleDatesDropDown">
                            <span v-html="$t('DigitalClassrooms.show_dates_and_times')"></span>
                            <span :class="['icon-dropdown', getClassForDateDropDown]"></span>
                        </span>
                    </div>
                    <div class="digital-classrooms-event__table-cell"></div>
                    <div class="digital-classrooms-event__table-cell">{{ getIntervalEventsTotalDuration }}</div>
                </template>
            </template>
            <template v-else>
                <template v-if="isDesktopView">
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__name">
                        <router-link :to="getRouteToCourse(event.course)">{{ event.title }}</router-link>
                    </div>
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__date">
                        <div v-for="(date, index) in getEventDates" :key="index">
                            {{ date }}
                            <span v-if="index != getEventDates.length - 1">&</span>
                        </div>
                    </div>
                    <div class="digital-classrooms-event__table-cell">{{ getEventTime }}</div>
                    <div class="digital-classrooms-event__table-cell">{{ getEventDuration }} </div>
                    <div v-if="!isPastEvent" class="digital-classrooms-event__table-cell">{{ getEventSeats }} </div>
                    <div v-else class="digital-classrooms-event__table-cell"></div>
                </template>
                <template v-else>
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__date">
                        <div v-for="(date, index) in getEventDates" :key="index">
                            {{ date }}
                            <span v-if="index != getEventDates.length - 1">&</span>
                        </div>
                    </div>
                    <div class="digital-classrooms-event__table-cell">{{ getEventTime }}</div>
                    <div class="digital-classrooms-event__table-cell">{{ getEventDuration }}</div>
                </template>
            </template>
            <DigitalClassRoomSignupButton
                v-if="isDesktopView && !isPastEvent"
                :isPastEvent="isPastEvent"
                :hasAccessToSignup="hasAccessToSignup"
                :course="course"
                :event="event"
                :hasSignedUpToSomeEvent="hasSignedUpToSomeEvent"
            />
        </div>
        <template v-if="getEventDates.length > 1">
            <div>
                <div :class="['digital-classrooms-event__table-row-interval', {'show' : showDateDropDown}]" >
                    <template v-if="isDesktopView">
                        <div class="digital-classrooms-event__table-cell"></div>
                        <div class="digital-classrooms-event__table-cell"></div>
                    </template>
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-dates">
                        <div class="digital-classrooms-event__interval-date" v-for="(session, index) in event.sessions" :key="index">
                            {{ getIntervalEventDate(session) }}
                        </div>
                    </div>
                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-times">
                        <div class="digital-classrooms-event__interval-time" v-for="(session, index) in event.sessions" :key="index">
                            {{ getIntervalEventTime(session) }}
                        </div>
                    </div>

                    <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-durations">
                        <div class="digital-classrooms-event__interval-duration" v-for="(session, index) in event.sessions" :key="index">
                            {{ getIntervalEventDuration(session) }}
                        </div>
                    </div>
                    <template v-if="isDesktopView">
                        <div class="digital-classrooms-event__table-cell"></div>
                        <div class="digital-classrooms-event__table-cell"></div>
                    </template>
                </div>
            </div>
        </template>
        <template v-if="isMobileView">
            <div class="digital-classrooms-event__table-row">
                <div v-if="!isPastEvent" class="digital-classrooms-event__table-cell">
                    <span class="digital-classrooms-event__seats-available"><span v-html="$t('DigitalClassrooms.seats')"></span>: {{ getEventSeats }}</span>
                </div>
                <div class="digital-classrooms-event__table-cell">
                    <DigitalClassRoomSignupButton
                        :isPastEvent="isPastEvent"
                        :hasAccessToSignup="hasAccessToSignup"
                        :course="course"
                        :event="event"
                        :hasSignedUpToSomeEvent="hasSignedUpToSomeEvent"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import routeHelper from 'components/shared/mixins/routeHelper'
    import digitalClassRoomHelper from 'components/shared/mixins/digitalClassRoomHelper'
    import DigitalClassRoomSignupButton from 'components/coursepage/courseaddons/digitalclassrooms/DigitalClassRoomSignupButton'

    export default {
        name: 'DigitalClassRoomEvent',
        components: { DigitalClassRoomSignupButton },
        mixins: [ routeHelper, digitalClassRoomHelper ],
        data () {
            return {
                isProcessingCancelSignUp: false,
                showDateDropDown: false
            }
        },
        props: {
            event: Object,
            course: Object,
            hasSignedUpToSomeEvent: Boolean,
            isPastEvent: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                signedUpEvents: 'Courses/getSignedUpEventsForUser',
                isCourseCompleted: 'CompletedCourses/isCourseCompleted'
            }),
            getClassForDateDropDown () {
                if (this.showDateDropDown) {
                    return 'open'
                } else {
                    return 'close'
                }
            },
            hasAccessToSignup () {
                return this.isLoggedIn && !this.course.demo
            }
        },
        methods: {
            toggleDatesDropDown () {
                this.showDateDropDown = !this.showDateDropDown
            },
            async onSignUpCancelAccepted () {
                this.$modal.hide('dialog')
                this.isProcessingCancelSignUp = true
                try {
                    await this.$store.dispatch('Courses/cancelSignUpForDigitalClassRoom',
                                               { courseId: this.event.course.id,
                                                 eventId: this.event.id,
                                                 subscriptionId: this.event.subscriptionId })
                    this.$emit('showPopupMessage', this.$t('DigitalClassrooms.signed_up_cancel_message'))
                } catch (e) {
                } finally {
                    this.isProcessingCancelSignUp = false
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon-dropdown {
        display: inline-block;
        &.open {
            transition: transform 0.3s ease;
            transform: rotate(-180deg);
        }
        &.close {
            transform: rotate(0deg);
            transition: transform 0.3s linear;
        }
    }
    @include digital-classrooms-table;
    @include digital-classrooms-event;
</style>
